import { Languages, Mic, Volume2 } from "lucide-react";

export default function TolokyIndicator({
  active = false,
  sourceLang = "",
  targetLang = "",
  speakerName = "",
  mode = "consecutive",
}) {
  if (!active) return null;

  return (
    <div className="bg-gradient-to-r from-violet-500 to-purple-600 text-white px-3 py-2 rounded-none text-xs flex items-center gap-3">
      <div className="flex items-center gap-1.5">
        <div className="w-5 h-5 bg-white/20 rounded flex items-center justify-center">
          <Languages className="w-3 h-3" />
        </div>
        <span className="font-medium">Toloky Interpreter</span>
      </div>

      <span className="text-white/60">|</span>

      {speakerName && (
        <span className="flex items-center gap-1 text-white/90">
          <Mic className="w-3 h-3" />
          {speakerName}
        </span>
      )}

      {sourceLang && targetLang && (
        <span className="flex items-center gap-1 text-white/90">
          <Volume2 className="w-3 h-3" />
          {sourceLang} → {targetLang}
        </span>
      )}

      <span className="text-white/60">|</span>

      <span className="text-[10px] uppercase tracking-wider text-white/70">
        {mode === "consecutive" ? "Consecutive" : "Real-time"}
      </span>

      <div className="ml-auto flex items-center gap-1">
        <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" />
        <span className="text-[10px] text-white/70">Active</span>
      </div>
    </div>
  );
}
